import React, { useRef, useState, useEffect } from "react";
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { FilterMatchMode } from "primereact/api";
import "primeicons/primeicons.css";

import { TabView, TabPanel } from "primereact/tabview";
import instance from "../../api/api.js";
import { useDispatch } from "react-redux";

import AllCompomentShared from "../../shared/compoments/AllCompomentShared.jsx";
import { IoMdPaper, IoMdEye } from "react-icons/io";
import { styleIcone } from "../../shared";
import { TbFileInvoice } from "react-icons/tb";
import { MdCommentsDisabled } from "react-icons/md";
import { MenuPoint, ModalDelete } from "../../shared/compoments";
import { showModal } from "../../store/slice/PrintSlice";
import { add_Client_id_propriety_id } from "../../store/slice/contrat/Contrat.js";

const StatutColor = {
  active: "green",
  desactive: "crimson",
};
const nameStatutContrat = {
  active: "En cours",
  desactive: "annulé",
};

function ListeSouscription() {
  const [contrats, setContrats] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const ITEMSFILTER = ["user", "service", "montant", "date", "status"];
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    nom: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    email: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    phone: { value: null, matchMode: FilterMatchMode.EQUALS },
    status: { value: null, matchMode: FilterMatchMode.EQUALS },
  });

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };
  useEffect(() => {
    const getListContrat = async () => {
      try {
        const response = await instance.get("contracts");
        console.log("getListContrat", response);
        setContrats(response.data.data.sort((a, b) => b.flag - a.flag));
        setIsLoading(false);
      } catch (error) {
        console.log(error);
        setIsLoading(false);
      }
    };
    getListContrat();
  }, []);

  return (
    <AllCompomentShared
      libelleHeaderComp={"Liste des contrats"}
      titleStatisticHeaderComp={"Nombre de contrats"}
      nbreTotalStatistiqueComp={contrats.length}
      SearchTableIsSearch={true}
      placeholderInputSearch={"Recherche"}
      globalFilterValue={globalFilterValue}
      onGlobalFilterChange={onGlobalFilterChange}
      iconeStatistiqueHeader={<IoMdPaper fontSize={"2em"} />}
      isLoading={isLoading}>
      <ContratDatatable
        items={contrats}
        isLoading={isLoading}
        ITEMSFILTER={ITEMSFILTER}
        filters={filters}
      />
    </AllCompomentShared>
  );
}
export function ContratDatatable({ items, ITEMSFILTER, filters }) {
  const dispatch = useDispatch();
  const [whyUseModalDelete, setWhyUseModalDelete] = useState("desactive");
  const dt = useRef(null);
  const [useIdData, setUseIdData] = useState("");
  const MySwal = withReactContent(Swal);
  const getAllId = (idContrat) => {
    const element = items.find((item) => Number(item.id) === Number(idContrat));
    const { client_id, propriety_id } = element;
    dispatch(
      add_Client_id_propriety_id({
        client_id: client_id,
        propriety_id: propriety_id,
      })
    );
    dispatch(showModal());
  };
  const options = [
    {
      name: "Voir plus",
      path: "/contrats/",
      icone: <IoMdEye style={styleIcone} />,
      isIdData: true,
    },
    {
      name: "Renouveler le contrat",
      addMethodClick: true,
      icone: <TbFileInvoice style={styleIcone} />,
      isIdData: true,
      methode: (idData) => {
        setWhyUseModalDelete("renouveler");
        console.log("idData", idData);
        setUseIdData(idData);
        getAllId(idData);
      },
    },
    {
      name: "Annuler",
      addMethodClick: true,
      icone: <MdCommentsDisabled style={styleIcone} />,
      isIdData: true,
      methode: (idData) => {
        setWhyUseModalDelete("desactive");
        console.log("idData", idData);
        setUseIdData(idData);
        dispatch(showModal());
      },
    },
  ];
  const getStatut = (rowData) => {
    return (
      <span
        className="badge"
        style={{ background: StatutColor[rowData.statut] }}>
        {nameStatutContrat[rowData.statut]}
      </span>
    );
  };

  const getNameClient = (rowData) => {
    return (
      <p>
        {rowData.client.nom} {rowData.client.prenom}
      </p>
    );
  };

  const getDateCreated = (rowData) => {
    return <p>{new Date(rowData.created_at).toLocaleDateString("fr")}</p>;
  };

  const detailsInfo = (rowData) => {
    return (
      <MenuPoint
        optionMenu={options}
        idData={rowData.id}
        statut={rowData.statut}
      />
    );
  };

  return (
    <div>
      <ModalDelete
        modalTitle={
          whyUseModalDelete === "desactive"
            ? "Voulez-vous vraiment Désactiver ce contrat ?"
            : "Renouvellement de contrat"
        }
        dataInfoForBtn={
          whyUseModalDelete === "desactive"
            ? [
                {
                  libelleBtn: "Oui",
                  color: "error",
                  methode: async () => {
                    console.log(useIdData);
                    try {
                      const response = await instance.post(
                        "deactivateContract/" + useIdData
                      );
                      console.log("response", response["status"]);
                      if (response["status"] === 200) {
                        const element = items.find(
                          (item) => Number(item.id) === Number(useIdData)
                        );
                        console.log("element", element);
                        element.statut = "desactive";
                        MySwal.fire({
                          title: response.data.message,
                          icon: "info",
                          showConfirmButton: true,
                        });
                        dispatch(showModal());
                      }
                      console.log("deactivateContract", response);
                    } catch (error) {
                      console.log(error);
                    }
                  },
                },
                {
                  libelleBtn: "Non",
                  isStyle: true,
                  methode: () => {
                    dispatch(showModal());
                  },
                },
              ]
            : [
                // {
                //   libelleBtn: "Enregistrer",
                //   methode: async () => {
                //     console.log(useIdData);
                //     const element = items.find(
                //       (item) => Number(item.id) === Number(useIdData)
                //     );
                //     const { client_id } = element;
                //     console.log(client_id);
                //   },
                // },
                // {
                //   libelleBtn: "Non",
                //   color: "error",
                //   isStyle: true,
                //   methode: () => {
                //     dispatch(showModal());
                //   },
                // },
              ]
        }
        isRenouvellementContrat={
          whyUseModalDelete === "desactive" ? false : true
        }
      />
      <TabView>
        <TabPanel>
          <DataTable
            ref={dt}
            value={items}
            tableStyle={{ minWidth: "50rem" }}
            paginator
            rows={10}
            filters={filters}
            globalFilterFields={ITEMSFILTER}>
            <Column
              field="id"
              style={{ textAlign: "center", position: "relative" }}
              header="Statut"
              body={getStatut}></Column>
            <Column
              field="id"
              style={{ textAlign: "center", position: "relative" }}
              header="Date d'emission"
              body={getDateCreated}></Column>
            <Column
              field="reference"
              style={{ textAlign: "center", position: "relative" }}
              header="Référence"></Column>
            <Column
              field="client_id"
              style={{ textAlign: "center", position: "relative" }}
              header="Client"
              body={getNameClient}></Column>
            <Column
              field="date_entree"
              style={{ textAlign: "center" }}
              header="Date début"></Column>
            <Column
              field="date_sortie"
              style={{ textAlign: "center" }}
              header="Date fin"></Column>
            <Column
              field="id"
              style={{ textAlign: "center" }}
              header="Actions"
              body={detailsInfo}></Column>
          </DataTable>
        </TabPanel>
      </TabView>
    </div>
  );
}

export default ListeSouscription;
